export const environment = {
  production: false,
  secretKey: '1P3YA29TRV705IK5', //ZestDigicore90012
  BASE_URL: 'https://api.dev.gateway.zestpayment.com/payment-engine', //'https://uat.digicoreltd.com/zest-web-engine'
  NETHONE_SCRIPT_URL:
    'https://d2sytucvh9dcel.cloudfront.net/s/125511/dVrOny.js',
};